import { useGoogleOneTapPrompt } from "@/utils/useGoogleOneTapPrompt";

export default function GoogleOneTap() {
  useGoogleOneTapPrompt();
  return null;
}